export const config = {
    defaultLocale: 'es',
    locales: ['es', 'en', 'it', 'deu', 'ru', 'fr', 'ca', 'gl', 'eu', 'nld'],
    nameApp: 'Barify',
    webApiBase: process.env.VUE_APP_ROOT_API
};
